/**
 * Common values intended for use with border-radius CSS property in KM.
 *
 * Usage example:
 *
 * const CircularElement = styled.div`
 *   width: 50px;
 *   height: 50px;
 *   border-radius: ${({ theme }) => theme.km.borderRadius.half};
 * `;
 */ export var borderRadius = {
    s: "4px",
    m: "8px",
    l: "12px",
    xl: "16px",
    xxl: "20px",
    /**
   * border-radius: 50% will render fully rounded corners, because it's using a
   * radius of half an element's width / height. In practice, when applied to a
   * box this forms an elipse, and applied to a square this forms a circle.
   */ half: "50%"
};
